import { AbstractControl, ValidatorFn } from '@angular/forms';

export function WhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (control.value && control.value.trim().length === 0) {
      return { 'whitespace': true };
    }

    return null;
  };
}
